module.exports = __webpack_public_path__ + "img/00048.6449ce4e.webp";